import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

(function () {
  //Testimonial-Slider
  const mbTestimonialSlider = document.querySelectorAll(".testimonials-slider");
  let testimonialSwiper = [];

  for (let i = 0; i < mbTestimonialSlider.length; i++) {
    const paginationEl = mbTestimonialSlider[i]
        .closest(".com-testimonials")
        .querySelector(".swiper-pagination");
    const navigationWrapper = mbTestimonialSlider[i]
        .closest(".com-testimonials")
        .querySelector(".swiper-navigation");
    const nextEl = navigationWrapper.querySelector(".swiper-button-next");
    const prevEl = navigationWrapper.querySelector(".swiper-button-prev");

    testimonialSwiper[i] = new Swiper(mbTestimonialSlider[i], {
      modules: [Pagination, Navigation],
      loop: false,
      slidesPerView: "auto",
      spaceBetween: 25,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      }
    });
  }

  //load more Btn in grid 
  const loadMoreBtn = document.getElementById('load-more-testimonials');

  if (loadMoreBtn != null && loadMoreBtn != 'undefined') {
    loadMoreBtn.addEventListener('click', function(e) {
      const testimonials = loadMoreBtn
        .closest(".com-testimonials")
        .querySelectorAll(".single-testimonial");
  
        let count = 0;
        let countActive = 0;
  
        for (let i = 0; i < testimonials.length; i++) {
          if (!testimonials[i].classList.contains('active') && count < 9) {
            testimonials[i].classList.add('active');
            count++;
            countActive++;
          } else {
            if (testimonials[i].classList.contains('active')) {
              countActive++
            }
          }
        }
  
        if (countActive >= testimonials.length) {
          loadMoreBtn.classList.add('inactive');
        }
    });
  }
})();
